import React, { useState, useEffect } from 'react';
import './V1HomePage.css';
import './themes/premium.theme.css';
import './themes/energetic.theme.css';
import V1HeroSection from '../../components/v1/V1HeroSection';
import V1SocialProof from '../../components/v1/V1SocialProof';
import V1ProblemSection from '../../components/v1/V1ProblemSection';
import V1SolutionSection from '../../components/v1/V1SolutionSection';
import V1CaseStudy from '../../components/v1/V1CaseStudy';
import V1ExamPrograms from '../../components/v1/V1ExamPrograms';
import V1PricingFunnel from '../../components/v1/V1PricingFunnel';
import V1FAQSection from '../../components/v1/V1FAQSection';
import ThemeToggle from '../../components/v1/ThemeToggle';
import StickyFooterCTA from '../../components/v1/StickyFooterCTA';
import ContactSection from '../../components/ContactSection';

export type V1Theme = 'premium' | 'energetic';

const V1HomePage: React.FC = () => {
  const [theme, setTheme] = useState<V1Theme>(() => {
    const saved = localStorage.getItem('v1-theme');
    return (saved === 'energetic' ? 'energetic' : 'premium') as V1Theme;
  });

  const [showStickyFooter, setShowStickyFooter] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute('data-v1-theme', theme);
    localStorage.setItem('v1-theme', theme);
  }, [theme]);

  useEffect(() => {
    const handleScroll = () => {
      setShowStickyFooter(window.scrollY > 800);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const toggleTheme = () => {
    setTheme(prev => prev === 'premium' ? 'energetic' : 'premium');
  };

  return (
    <div className="v1-page" data-theme={theme}>
      <ThemeToggle currentTheme={theme} onToggle={toggleTheme} />

      <V1HeroSection theme={theme} onCTAClick={scrollToContact} />
      <V1SocialProof theme={theme} />
      <V1ProblemSection theme={theme} />
      <V1SolutionSection theme={theme} onCTAClick={scrollToContact} />
      <V1CaseStudy theme={theme} onCTAClick={scrollToContact} />
      <V1ExamPrograms theme={theme} />
      <V1PricingFunnel theme={theme} onCTAClick={scrollToContact} />
      <V1FAQSection theme={theme} />

      <div id="contact">
        <ContactSection />
      </div>

      {showStickyFooter && (
        <StickyFooterCTA theme={theme} onClick={scrollToContact} />
      )}
    </div>
  );
};

export default V1HomePage;
